// extracted by mini-css-extract-plugin
module.exports = {"noselect":"styles_noselect__1ae9H"};